import { useEffect, useState } from 'react';
import Select from 'react-select';
import CustomAlert from '@components/Shared/Alert/CustomAlert';
import { useAppDispatch, useAppSelector } from '@store/hooks';
import { ItemSupplierInItem } from '@store/INV/AssignmentItems/itemsSupplierSlice';
import { useTranslation } from 'react-i18next';
import { useParams } from 'react-router-dom';
import Loading from '@components/Shared/Loader/Loading';
import useGetSuppliersList from '@hooks/NTX/Peoples/useGetSuppliersList';
import { getSuppliersByItemId } from '@store/INV/MasterItems/MasterItemsSlice';

const ItemsSupplier = () => {
  const { t } = useTranslation();
  const [isSubmitting, setIsSubmitting] = useState(false);
  const dispatch = useAppDispatch();
  const [SupplierIds, setSupplierIds] = useState<any[]>([]);
  const { ItemId } = useParams();
  // const { ItemsOptions } = useGetItemsList();

  const { OptionSuppliers } = useGetSuppliersList();

  useEffect(() => {
    if (ItemId) {
      dispatch(getSuppliersByItemId(ItemId));
    }
  }, [ItemId, dispatch]);

  const {
    SuppliersByItemId: data,
    SuppliersLoading: loading,
    SuppliersError: error
  } = useAppSelector(a => a.MasterItemsINV);

  useEffect(() => {
    if (data && data?.length > 0) {
      const selectedSupplier = data?.map((m: any) => m.supplierId); // استخرج الـ IDs من البيانات
      setSupplierIds(selectedSupplier);
    }
  }, [data]);

  const onSubmit = () => {
    setIsSubmitting(true);

    const body = {
      supplierIds: SupplierIds,
      itemId: ItemId
    };

    dispatch(ItemSupplierInItem(body))
      .unwrap()
      .then(res => {
        if (res.succeeded) {
          CustomAlert({ action: 'Add' });
        } else {
          CustomAlert({ action: 'Error', msg: res.message });
        }
      })
      .catch((error: any) => {
        CustomAlert({ action: 'Error' });
      })
      .finally(() => {
        setIsSubmitting(false);
      });
  };

  return (
    <>
      <Loading loading={loading} error={error}>
        <div className='col-12'>
          <label className='form-label'>{t('SelectItemSuppliers')}</label>
          <div className='input-group flex-nowrap'>
            <Select
              classNamePrefix='react-select'
              className=' w-100'
              required
              isMulti
              options={OptionSuppliers}
              value={OptionSuppliers?.filter((option: any) => SupplierIds.includes(option.value))} // تحديد القيم الافتراضية
              onChange={e => {
                setSupplierIds(e?.map((m: any) => m.value));
              }}
            />
          </div>
        </div>

        <div className='text-end mt-3'>
          <button
            disabled={isSubmitting}
            onClick={() => onSubmit()}
            type='submit'
            className='btn me-1 btn-theme mb-1'
            id='SaveSubmit'
          >
            {isSubmitting ? (
              <div className='spinner-border spinner-border-sm me-2'></div>
            ) : (
              <i className='fa fa-save btn-lg fa-fw me-1'></i>
            )}
            {t('Save')}
          </button>
        </div>
      </Loading>
    </>
  );
};

export default ItemsSupplier;
